<template>
  <div v-if="isAuthenticated">
    <div class="panel">
      <h1>Your Surveys</h1>

      <div class="list-view" v-if="surveys.length > 0">
        <div class="list-view__header">
          <div>Title</div>
          <div>Status</div>
          <div>Invited On</div>
        </div>
        <div class="list-view__row" v-for="survey in incompleteSurveys">
          <div><router-link :to="responseLink(survey)">{{ survey.title }}</router-link></div>
          <div>{{ responseStatus(survey) }}</div>
          <div>{{ formatDateShort(survey.invited_on) }}</div>
        </div>
      </div>
      <div v-else><em>You have no active surveys</em></div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';
  import DateFormatter from '@/mixins/date';

  export default {
    name: 'index',

    mixins: [DateFormatter],

    computed: {
      ...mapState({
        surveys: state => state.survey.surveys,
        surveysLoaded: state => state.survey.surveysLoaded,
      }),

      ...mapGetters([
        'isAuthenticated',
        'responseStatus',
        'incompleteSurveys',
      ]),
    },

    watch: {
      isAuthenticated() {
        if (this.isAuthenticated && !this.surveysLoaded) {
          this.fetchSurveys();
        }
      },
    },

    methods: {
      ...mapActions([
        'fetchSurveys',
      ]),

      responseLink(survey) {
        if (survey.response && !survey.response.complete) {
          return {
            name: 'survey-resume',
            params: {
              surveyRef: survey.reference,
              surveyId: survey.response.id,
              pageId: survey.response.next_page,
            },
          };
        }
        return {
          name: 'survey-new',
          params: {
            surveyRef: survey.reference,
            surveyInviteId: survey.invite_id,
            hasLastResponse: survey.has_last_response,
          },
        };
      },
    },

    created() {
      if (this.isAuthenticated) {
        this.fetchSurveys();
      }
    },
  };
</script>
